import angular from 'angular'

import table from 'text-table'
import envRaw from '../utils/env-raw'

import { flatten, isObject, truncate } from 'lodash-es'

angular
  .module('ggs.properties')
  .factory('printPropertiesDiff', printPropertiesDiffProvider)

function printPropertiesDiffProvider($log) {
  let lastTimeoutId = null
  const queue = []
  const delay = 1e3

  return printPropertiesDiff

  function printPropertiesDiff(diff) {
    if (envRaw.showsPropertiesDebug) {
      if (diff.length === 1) {
        printOneLine(diff)
      } else if (diff.length > 1) {
        printMultiLine(diff)
      }
    }
    return diff
  }

  function printOneLine(diff) {
    clearTimeout(lastTimeoutId)
    const chunk = diff[0]
    chunk.timestamp = Date.now()
    queue.push(chunk)
    lastTimeoutId = setTimeout(printOneLineCallback, delay)
  }

  function printOneLineCallback() {
    const diff = flatten(queue)
    queue.length = 0
    $log.info(`Properties: summary diff for last ${delay}ms \n${fmtTable(diff, fmtRowWithTimestamp)}`)
  }

  function printMultiLine(diff) {
    $log.info(`Properties: result diff \n${fmtTable(diff, fmtRow)}`)
  }

  function fmtTable(diff, fmtRowFunc) {
    return table(diff.map(fmtRowFunc))
  }

  function fmtRow(chunk) {
    const lhs = isObject(chunk.lhs)
      ? JSON.stringify(chunk.lhs)
      : '' + chunk.lhs
    const rhs = isObject(chunk.rhs)
      ? JSON.stringify(chunk.rhs)
      : '' + chunk.rhs
    const lhsTrn = truncate(lhs, { length: 150 })
    const rhsTrn = truncate(rhs, { length: 150 })
    return [`[${chunk.kind}] ${chunk.path.join('.')}:`, lhsTrn, '->', rhsTrn]
  }

  function fmtRowWithTimestamp(chunk) {
    const chunkArr = fmtRow(chunk)
    chunkArr.unshift(chunk.timestamp)
    return chunkArr
  }
}
